import { shopPrefix } from '../../config';
import { ProductsResponseOut } from '../../store/api';
import { http } from '../axios';
import { Pagination } from '../../../models/Pagination';
import { mapLoanFormat } from '../../../models/LoanFormat';

type Params = {
    readonly pagination: Pagination;
    readonly filterMap: string;

    readonly loanFormat: string;
    readonly ageCategory?: string;
    readonly shopLanguage?: string;
};

const url = `${shopPrefix}/v2/standard/allproducts/:loanFormat/products`;

export const fetchAllProductsProducts = ({ pagination, filterMap, loanFormat, ageCategory, shopLanguage }: Params) => {
    return http
        .post<ProductsResponseOut>(url, filterMap ?? {}, {
            pathParams: { loanFormat },
            params: {
                ...pagination,
                ageCategory,
                shopLanguage
            }
        })
        .then(response => response.data)
        .then(data => {
            const hits = data.hits?.map(item => ({ ...item, loanFormat: mapLoanFormat(item.loanFormat) }));
            return {
                ...data,
                hits
            };
        });
};
